import { initializeApp } from 'firebase/app'
import { getMessaging, getToken, onMessage } from 'firebase/messaging'

const firebaseBapp = initializeApp({
  apiKey: 'AIzaSyAccn3HlR0PI6EUfZxZIvsOYzuDu-ECVDE',
  authDomain: 'amadaychoob-f85f8.firebaseapp.com',
  projectId: 'amadaychoob-f85f8',
  storageBucket: 'amadaychoob-f85f8.appspot.com',
  messagingSenderId: '893331414749',
  appId: '1:893331414749:web:6ff724e5412a70b6234534',
  measurementId: 'G-MY85P2SDHK',
})

let messaging
try {
  messaging = getMessaging(firebaseBapp)
} catch (ex) {
  console.log(
    "This browser doesn't support the API's required to use the Firebase SDK. (messaging/unsupported-browser).",
  )
}
// Retrieve firebase messaging

export const checkFirebaseToken = async () => {
  let firebaseToken = localStorage.getItem('listenerId')
  if (!firebaseToken) {
    let token = await requestForToken()
    if (token) {
      return token
    } else {
      console.log('cannot get firebase token!')
    }
  }
  return firebaseToken
}

export const requestForToken = async () => {
  if (messaging) {
    let data = await getToken(messaging, {
      vapidKey:
        'BJY5YLKKQHwbHmcVXUeCHL3EXLK0Dgy1tAO7k95GuQhqG066B8LVN2veQ3Pk0xcmb3EPdm4qMLV9OKHOE4aCncM',
    })
    return data
  }
}

onMessage(messaging, (payload) => {
  const receiveNotification = new CustomEvent('onReceiveNotification', {
    bubbles: true,
    cancelable: true,
    composed: false,
    detail: { ...payload?.data },
  })

  window.dispatchEvent(receiveNotification)
})

// export const onMessageListener = () =>
//   new Promise((resolve) => {
//     if (messaging) {
//       onMessage(messaging, (payload) => {
//         const receiveNotification = new CustomEvent('onReceiveNotification', {
//           detail: { ...payload?.data },
//           bubbles: true,
//           cancelable: true,
//           composed: false,
//         })
//         window.dispatchEvent(receiveNotification)
//         resolve(payload)
//       })
//     }
//   })

/* eslint-disable no-restricted-globals */
